"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.definition = void 0;
var tslib_1 = require("tslib");
var joi_1 = tslib_1.__importDefault(require("joi"));
var endpoint_definition_details_generator_1 = require("../../../helpers/endpoint.definition.details.generator");
var api_response_def_1 = require("../../../shared/api.response.def");
var collection_json_def_1 = require("../../../shared/collection.json.def");
var response = joi_1.default.object({
    results: joi_1.default.array().items(collection_json_def_1.collection)
});
exports.definition = (0, endpoint_definition_details_generator_1.makeDefinitionFor)('/collection.json?jobId={job_id}', {
    description: 'Get an array of collections in the supplied job ID',
    method: 'get',
    summary: 'Collection list',
    tags: ['Collection'],
    params: [
        {
            $ref: '#/components/parameters/ikeDepartmentId'
        },
        {
            $ref: '#/components/parameters/jobIdPath'
        }
    ]
}, [
    {
        code: 200,
        description: api_response_def_1.success,
        schema: response
    },
    (0, api_response_def_1.generateValidationError)()
]);
//# sourceMappingURL=collection.list.get.schema.js.map